import {ReactNotifications, Store} from "react-notifications-component";
import React from 'react';
import {AppState} from "../RootReducer";
import {connect} from "react-redux";
import { AppContext, UserMessage } from "../http/protocol";
import {RouteComponentProps, withRouter} from "react-router";
import {Dispatch} from "redux";
import {clearToasts} from "../messages/MessageActions";
import {SettingsService} from "../settings/SettingsService";
import {getContainer} from "../ioc/IOCSetup";


interface Props extends RouteComponentProps {
    toasts : UserMessage[];
}
interface State {disabled: boolean};
export class ToastHandlerImpl extends React.Component< Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { disabled : false }
    }
    componentDidMount() {
       let disabled =  SettingsService.getInstance(getContainer().getHttpService()).isToastsDisabled();
       if(disabled) {
           this.setState({ disabled : true });
       }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if(this.state.disabled == false && this.props.toasts.length > 0 && prevProps.toasts.length != this.props.toasts.length) {
            let messages = this.props.toasts;
            messages.forEach(m => {
                if(m.title && m.message && !m.hideToast) {
                    addToast(()  => this.props.history.push("/account/messages"), m.title, m.message);
                }
            });
            clearToasts();
        }
    }

    render() {
        return (
            <ReactNotifications />
        )
    }
}
export const ToastHandler = connect((app: AppState) => {
    const isGlifeAppContext = app.settings.appContext === AppContext.GLIFE

    // if the app context is glife, don't show toasts
    const toasts = isGlifeAppContext ? [] : app.user?.toasts

    return {
        toasts : toasts
    }
},
(dispatch: Dispatch) => {
    return {
        clear : () => dispatch(clearToasts())
    }
})(withRouter(ToastHandlerImpl as any) as any);
export const addToast = (onClick : () => void, title : string, message : string, imageUrl? : string, duration: number = 3000)  => {
    Store.addNotification(
        {
            container : "top-right",
            title : <span dangerouslySetInnerHTML={{__html : title}}></span>,
            message : <span dangerouslySetInnerHTML={{__html : message}}></span>,
            type : "info",
            onRemoval: (id: string, removedBy: any) => {
                if(removedBy != "timeout") {
                    onClick();
                }
            },
            dismiss: {
                click : true,
                touch : true,
                duration: duration,
                onScreen: true
            }
        });
}

